import * as t from 'io-ts';

import { BillingCardModelC } from './billing-card-model';


export const PaymentSourcesModelC = t.intersection(
  [
    t.type({
      cards: t.array(BillingCardModelC),

    }),
    t.partial({
      primaryCardId: t.string,
      backupCardId: t.string,
      billingCountry: t.string,
      vatNumber: t.string,
    }),
  ],
  'PaymentSourcesModel');

export type PaymentSourcesModel = t.TypeOf<typeof PaymentSourcesModelC>;

